/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {
  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    common: {
      init: function() {
        // $('.navbar-toggler').on('click', function(){
        //   $('.sticky-nav-footer').toggle("toggle-footer-nav");
        // });

        // BEGIN: External links
        $("a[rel=external]").each(function() {
          $(this).attr("target", "_blank");
        });

        // Toggle Arrow Img
        $(".show-less").click(function() {
          $(this).toggleClass("show");
        });

        // Toggle Q&A
        $("div.show-more").show();
        $("div.show-less").click(function() {
          $(this)
            .next()
            .stop()
            .slideToggle();
          $(this).attr("aria-expanded", function(i, attr) {
            return attr == "true" ? "false" : "true";
          });
          $(this)
            .find(".accordian-arrow-locations, img")
            .attr("aria-expanded", function(i, attr) {
              return attr == "true" ? "false" : "true";
            });
        });

        // Opens accordion if enter key is pressed
        $(".show-less").keypress(function(e) {
          var keycode = e.keyCode ? e.keyCode : e.which;
          if (keycode == "13") {
            $(this).click();
          }
        });

        $("div.show-more, div.show-less").keypress(function(evt) {
          var charCode = evt.charCode || evt.keyCode;
          if (charCode == 13) {
            $(this)
              .next()
              .stop()
              .slideToggle();
            $(this).toggleClass("show");
            $(this).attr("aria-expanded", function(i, attr) {
              return attr == "true" ? "false" : "true";
            });
            $(this)
              .find(".accordian-arrow-locations, img")
              .attr("aria-expanded", function(i, attr) {
                return attr == "true" ? "false" : "true";
              });
          }
        });

        $(".nav-link").keypress(function(evt) {
          var charCode = evt.charCode || evt.keyCode;
          if (charCode == 13) {
            return;
          }
        });

        $("div.show-more, div.show-less").keypress(function(evt) {
          var charCode = evt.charCode || evt.keyCode;
          if (charCode == 13) {
            $(this)
              .next()
              .stop()
              .slideToggle();
            $(this).toggleClass("show");
            $(this).attr("aria-expanded", function(i, attr) {
              return attr == "true" ? "false" : "true";
            });
            $(this)
              .find(".accordian-arrow-locations, img")
              .attr("aria-expanded", function(i, attr) {
                return attr == "true" ? "false" : "true";
              });
          }
        });

        // Highlight navbar menu item when on page
        $(".navbar-nav .nav-item a").each(function() {
          if ($(this).prop("href") == window.location.href) {
            $(this).addClass("current");
          }
        });

        // Hamburger Menu Toggle
        $(".navbar-toggler").on("click", function() {
          $(".hamburger-menu").toggleClass("animate");
        });

        // Find all trademarks & wrap in <sup>
        $("body")
          .html()
          .replace(
            /((?!<sup>\s*))&trade;((?!\s*<\/sup>))/gi,
            "<sup>&trade;</sup>"
          ); // wrap &trade; if not wrapped yet

        // Adds a class when the mobile nav is open
        $(".navbar-toggler").click(function() {
          $(".navbar").toggleClass("nav-expanded");
        });

        // Making all buttons, a tags tabbable
        $(".show-less").each(function() {
          $(this).attr("tabindex", "0");
        });

        // Making all buttons, a tags tabbable
        $(".nav-item").each(function() {
          $(this).attr("tabindex", "-1");
        });

        // Making all buttons, a tags tabbable
        $(".nav-link").each(function() {
          var name = $(this).html();
          $(this).attr({
            tabindex: "0",
            "aria-label": name + " Main Nav Item",
            type: "link"
          });
        });

        // Making all buttons, a tags tabbable
        $(".social-icon").each(function() {
          $(this).attr({
            tabindex: "-1",
            type: "link"
          });
        });

        // // Making all buttons, a tags tabbable
        $("#footer-social>li").each(function() {
          $(this).attr("tabindex", "0");
        });

        // // Making all inputs and textareas tabindex 0
        $("input, textarea, select").each(function() {
          $(this).attr("tabindex", "0");
        });

        // Makes CTA clickable
        $(".details-title").keypress(function(e) {
          var keycode = e.keyCode ? e.keyCode : e.which;
          if (keycode == "13") {
            $(this).click();
          }
        });

        // Animate floating label when autocomplete is selected
        // $('.floating-label input, .floating-label textarea').on('input propertychange paste autocompleteselect', function () {
        //   $(this).closest(".floating-label").addClass("float-placeholder");
        // });

        // $(window).load(function(){
        //   if($('.chrome input:-webkit-autofill')){
        //     $(".floating-label").hover(function(){
        //       $(".floating-label").addClass("float-placeholder");
        //     });
        //   }
        // });

        // Remove empty paragraph tags
        $("p:empty").remove();

        // Increment tab length
        // function getTabLength(){
        //   $('.add-focus').attr('tabindex',function(i) {
        //     return  i + 1;
        //   });
        // }
        // setTimeout(getTabLength, 5000);

        // Opacity Animation to mimic Lazy Load
        function startAnimationQueue(element) {
          return function(next) {
            element.addClass("in");
            next();
          };
        }

        function loadAnimationQueue() {
          var queue = $({}); //use the default animation queue
          $(".stagger").each(function() {
            queue.queue(startAnimationQueue($(this)));
            queue.delay(150);
          });
        }

        loadAnimationQueue();

        // $(".featured").hover(
        //   function() {
        //   $("#show-pause").show()
        //   },
        //   function() {
        //     $("#show-pause").hide();
        //   }
        // );

        var videoExists = document.getElementsByTagName("video");
        var currentPage = window.location.origin;
        if (videoExists.length) {
          var findVideoId = $("video").attr("id");
          var videoId = "#" + findVideoId + "";
          var imgs = [new Image(), new Image()];
          var currentPage = window.location.origin;

          imgs[0].src =
            currentPage +
            "/wp-content/themes/torchystacos/dist/images/icons/pause-btn-video.png";
          imgs[1].src =
            currentPage +
            "/wp-content/themes/torchystacos/dist/images/icons/play-btn-video.png";
          // append pause button
          $(".video-wrap").append(
            '<img src="' +
              imgs[0].src +
              '" class="add-video-btn ada-pause" data-video="' +
              videoId +
              '" height="25" width="25"/>'
          );
          // append play button
          $(".video-wrap").append(
            '<img src="' +
              imgs[1].src +
              '" class="add-video-btn ada-play" data-video="' +
              videoId +
              '" height="25" width="25"/>'
          );
        }

        $("video").one("mouseenter", function() {
          $(".ada-pause").show();
        });

        $(".ada-pause").on("click", function() {
            var getParentID = $(this).parent().find('video');
          $(getParentID)
            .get(0)
            .pause();
          $(".ada-play").show();
          $(".ada-pause").hide();
        });

        $(".ada-play").on("click", function() {
            var getParentID = $(this).parent().find('video');
          $(getParentID)
            .get(0)
            .play();
          $(".ada-pause").show();
          $(".ada-play").hide();
        });
      },
      finalize: function() {
        // JavaScript to be fired after the init JS
      }
    },
    // Home page
    home: {
      init: function() {
        function updateText(event) {
          var input = $(this);
          setTimeout(function() {
            var val = input.val();
            if (val != "")
              $(input)
                .closest(".floating-label")
                .addClass("float-placeholder");
            else
              $(input)
                .closest(".floating-label")
                .removeClass("float-placeholder");
          }, 1);
        }
        $(".floating-label input").keydown(updateText);
        $(".floating-label input").change(updateText);
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // Locations Overview
    locations: {
      init: function() {
        // JavaScript to be fired on the newsroom page
        window.onresize = function(event) {
          $("#marker-tooltip").hide();
        };
      }
    },
    // Single Locations
    single_locations: {
      init: function() {
        // Slick Slider
        $(".slick-stores").slick({
          centerMode: true,
          arrows: true,
          slidesToShow: 1,
          infinite: true,
          speed: 300,
          backArrow:
            "<a href='javscript:void(0);' class='slick-custom-back'><span>Back</span></a>",
          nextArrow:
            "<a href='javscript:void(0);' class='slick-custom-next'><span>Next</span></a>",
          responsive: [
            {
              breakpoint: 992,
              settings: {
                arrows: false,
                dots: true,
                centerMode: false,
                slidesToShow: 1
              }
            },
            {
              breakpoint: 768,
              settings: {
                arrows: false,
                dots: true,
                centerMode: false,
                slidesToShow: 1
              }
            },
            {
              breakpoint: 480,
              settings: {
                arrows: false,
                dots: true,
                centerMode: false,
                slidesToShow: 1
              }
            }
          ]
        });
      }
    },
    // Work Here page
    careers: {
      init: function() {
        autoPlayYouTubeModal();

        //FUNCTION TO GET AND AUTO PLAY YOUTUBE VIDEO FROM DATATAG
        function autoPlayYouTubeModal() {
          var trigger = $("body").find('[data-toggle="modal"]');
          trigger.click(function() {
            var theModal = $(this).data("target"),
              videoSRC = $(this).attr("data-video"),
              videoSRCauto = videoSRC + "?autoplay=1&rel=0&showinfo=0";
            $(theModal + " iframe").attr("src", videoSRCauto);
            $(theModal + " button.close").click(function() {
              $(theModal + " iframe").attr("src", videoSRC);
            });
          });
        }

        // On video play button click, pause HMTL5 background video
        $("#video-play-btn").click(function() {
          $("#careersVideo")
            .get(0)
            .pause();
        });

        // On modal close, play HMTL5 background video
        $("#videoModal").on("hidden.bs.modal", function() {
          $("#careersVideo")
            .get(0)
            .play();
        });
        
        $("#work-videos .video-nav-item").on('click', function() {
          var target = $(this).attr('data-target-id');
          $("#work-videos .main-video-item").removeClass('active');
          $("#work-videos .video-nav-item").removeClass('active');
          $("#"+target).addClass('active');  
          $(this).addClass('active');
        })
        
      }
    },
    contact: {
      init: function() {
        // Select Menu
        $(".gfield select").addClass("selectpicker");
        
        $(".selectpicker").selectpicker({
          dropupAuto: false,
          template: {
            caret:
              '<img src="/wp-content/themes/torchystacos/dist/images/icons/triangle-down.png" class="down-arrow" alt="Arrow Icon">'
          }
        });


        // On dropdown open
        $(document).on("shown.bs.dropdown", function(event) {
          var dropdown = $(event.target);

          // Set aria-expanded to true
          dropdown.find(".dropdown-menu").attr("aria-expanded", true);

          // Set focus on the first link in the dropdown
          setTimeout(function() {
            dropdown.find(".dropdown-menu li:first-child a").focus();
          }, 10);
        });

        // On dropdown close
        $(document).on("hide.bs.dropdown", function(event) {
          var dropdown = $(event.target);
          // Set aria-expanded to true
          dropdown.find(".dropdown-menu").attr("aria-expanded", false);
        });

      }
    },
    submit_resume: {
      init: function() {
        // Select Menu
        $(".gfield select").addClass("selectpicker");

        $(".selectpicker").selectpicker({
          dropupAuto: false,
          template: {
            caret:
              '<img src="/wp-content/themes/torchystacos/dist/images/icons/triangle-down.png" class="down-arrow" alt="Arrow Icon">'
          }
        });

        // On dropdown open
        $(document).on("shown.bs.dropdown", function(event) {
          var dropdown = $(event.target);

          // Set aria-expanded to true
          dropdown.find(".dropdown-menu").attr("aria-expanded", true);

          // Set focus on the first link in the dropdown
          setTimeout(function() {
            dropdown.find(".dropdown-menu li:first-child a").focus();
          }, 10);
        });

        // On dropdown close
        $(document).on("hide.bs.dropdown", function(event) {
          var dropdown = $(event.target);
          // Set aria-expanded to true
          dropdown.find(".dropdown-menu").attr("aria-expanded", false);
        });

      }
    },
    single_menu_item: {
      init: function() {
        $(".move-area").mousemove(function(event) {
          var eye = $(".eye");
          var x = eye.offset().left + eye.width() / 2;
          var y = eye.offset().top + eye.height() / 2;
          // console.log(x, y);
          var rad = Math.atan2(event.pageX - x, event.pageY - y);
          //console.log(rad);
          var rot = rad * (180 / Math.PI) * -1 + 180;
          //console.log(rot);
          eye.css({
            "-webkit-transform": "rotate(" + rot + "deg)",
            "-moz-transform": "rotate(" + rot + "deg)",
            "-ms-transform": "rotate(" + rot + "deg)",
            transform: "rotate(" + rot + "deg)"
          });
        });
      }
    },
    news: {
      init: function() {
        var active_row = 1;
        var group_num = $(".group").length;

        $("body").on("click", "#load-more-posts", function(e) {
          e.preventDefault();

          active_row++;
          $('.group[data-row="' + active_row + '"]').slideDown("slow");

          if (active_row === group_num) {
            $("#load-more-posts").hide();
          }
        });
      }
    },
    locations: {
      init: function() {
        function updateText(event) {
          var input = $(this);
          setTimeout(function() {
            var val = input.val();
            if (val != "") input.parent().addClass("float-placeholder");
            else input.parent().removeClass("float-placeholder");
          }, 1);
        }
        $(".input-container input").keydown(updateText);
        $(".input-container input").change(updateText);
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = funcname === undefined ? "init" : funcname;
      fire = func !== "";
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === "function";

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire("common");

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, "_").split(/\s+/), function(
        i,
        classnm
      ) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, "finalize");
      });

      // Fire common finalize JS
      UTIL.fire("common", "finalize");
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);
})(jQuery); // Fully reference jQuery after this point.
